module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"dialog_title":"Rollendaten","close":"Abbrechen","ok":"ok"},"en":{"dialog_title":"Role data","close":"cancel","ok":"ok"},"nl":{"dialog_title":"Rolgegevens","close":"Annuleren","ok":"ok"}}')
  delete Component.options._Ctor
}
